import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "row align-items-center justify-content-between" }
const _hoisted_4 = { class: "table-responsive overflow-auto mt-3" }
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "popover-content position-left" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "popover-content position-left" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { class: "text-right" }

import overviewCoachingService from '@/api/CoachingOverview/AssistedLivingCoaching';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
// @ts-ignore
import {getArchivedAssistedLivingCoachingDropdown, getOfficeByUserRoleDropdown, getUserDropdown,} from '@/shared/dropdowns';
import {downloadFile, getSortIconClass} from '@/shared/functions';
import Menu from '@/views/App/CoachingOverview/AssistedLivingCoaching/Menu.vue';
import Search from '@/views/App/CoachingOverview/AssistedLivingCoaching/Archived/Search.vue';
import {computed, onMounted, ref} from 'vue';
import {
  ICoachingOverviewFilters,
  ICoachingOverviewList, IPagination
} from "@/interfaces/CoachingOverview/AssistedLivingCoaching/ICoachingOverview";
import {IClientFilters} from "@/interfaces/Client/IClient";
import {piniaUserStore} from "@/store/piniaUserStore";
import ClientSpecialFeaturesPopover from "@/components/ClientSpecialFeaturesPopover.vue";
// @ts-ignore
import {getUnitsInWeek} from "@/shared/functions";
import BackButton from "@/components/button/BackButton.vue";
import ExcelExportButton from "@/components/ExcelExportButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value?.roles?.[0];
const isExcelLoaded = ref(false);

const TypedPopover = ClientSpecialFeaturesPopover as unknown as {
  new (): {
    $slots: {
      trigger: () => any
      content: () => any
    }
  }
}


const filters = ref<ICoachingOverviewFilters>({
  unemployedLastName: '',
  coachId: '',
  officeId: '',
  startDate: '',
  endDate: '',
  page: 1,
  limit: 10,
  sortBy: 'firstName',
});

const unemployedDropdown = ref([]);
const coachDropdown = ref([]);
const officeDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const perPageValue = ref(25)
const coachingList = ref<ICoachingOverviewList>({
  data: [],
  pagination: {
    current_page: 1,
    items_per_page: 10,
    total_pages: 0,
  } as IPagination,
});

async function getCoachingList(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: IClientFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingList.value?.pagination?.items_per_page;

  perPageValue.value = perPage ?? perPageRes;

  try {
    const {data} = await overviewCoachingService.getArchivedList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes,
    });

    coachingList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

function getIconClass(key: string) {
  return getSortIconClass(filters.value, key);
}

async function sortBy(key: string) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy: filters.value.orderBy === 'DESC' || filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  await getCoachingList();
}

function getSelectedCoachesData(data: any) {
  if (Array.isArray(data) && data.length === 1) {
    return data[0]?.fullName;
  }
  if (Array.isArray(data) && data.length > 1) {
    return 'Mehrere';
  }

  return '';
}

async function getExcelExport() {
  await downloadFile('/assisted-living-coaching-overview/archived-excel-export',
      undefined,
      filters.value,
      false,
      "GET",
      isExcelLoaded
  )
}


onMounted(async () => {
  await Promise.all([
    getCoachingList(1, perPageValue.value),
    getArchivedAssistedLivingCoachingDropdown(unemployedDropdown),
    getUserDropdown(coachDropdown),
    getOfficeByUserRoleDropdown(officeDropdown),
  ]);

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BackButton, {
              label: _ctx.$t('general.button.back'),
              to: { name: 'coachingOverview' },
              marginBottom: "5"
            }, null, 8, ["label"]),
            _cache[44] || (_cache[44] = _createElementVNode("h6", { class: "element-header" }, "Übersicht", -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[43] || (_cache[43] = _createElementVNode("h5", { class: "form-header mb-4" }, "Betreutes Wohnen", -1)),
              _createVNode(Menu),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                unemployedDropdown: unemployedDropdown.value,
                officeDropdown: officeDropdown.value,
                coachDropdown: coachDropdown.value,
                onSearch: getCoachingList
              }, null, 8, ["filters", "loading", "unemployedDropdown", "officeDropdown", "coachDropdown"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createVNode(PerPage, {
                    values: [10, 25, 50, 100],
                    perPage: perPageValue.value,
                    "onUpdate:perPage": getCoachingList
                  }, null, 8, ["perPage"]),
                  _createVNode(ExcelExportButton, {
                    style: {"margin-right":"15px"},
                    label: _ctx.$t('general.excel_export'),
                    loading: isExcelLoaded.value,
                    onClick: getExcelExport
                  }, null, 8, ["label", "loading"])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("table", _hoisted_5, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[30] || (_cache[30] = _createElementVNode("th", null, null, -1)),
                      _cache[31] || (_cache[31] = _createElementVNode("th", null, null, -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (sortBy('status')), ["prevent"]))
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "status", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('status'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (sortBy('firstName')), ["prevent"]))
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Vorname", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('firstName'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (sortBy('lastName')), ["prevent"]))
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Nachname", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('lastName'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (sortBy('operationType')), ["prevent"]))
                        }, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Maßnahmenart", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('operationType'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (sortBy('aaNumber')), ["prevent"]))
                        }, [
                          _cache[19] || (_cache[19] = _createElementVNode("span", null, "JC/AA Nr", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('aaNumber'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (sortBy('location')), ["prevent"]))
                        }, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", null, "Standort", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('location'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (sortBy('fileNumberLandscapeAssociation')), ["prevent"]))
                        }, [
                          _cache[21] || (_cache[21] = _createElementVNode("span", null, "Aktenzeichen Landschaftsverband", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('fileNumberLandscapeAssociation'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (sortBy('startDate')), ["prevent"]))
                        }, [
                          _cache[22] || (_cache[22] = _createElementVNode("span", null, "Start", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('startDate'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (sortBy('endDate')), ["prevent"]))
                        }, [
                          _cache[23] || (_cache[23] = _createElementVNode("span", null, "Ende", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('endDate'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[32] || (_cache[32] = _createElementVNode("th", null, "FLS pro Woche", -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (sortBy('unitsDone')), ["prevent"]))
                        }, [
                          _cache[24] || (_cache[24] = _createElementVNode("span", null, "Stand", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('unitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (sortBy('unitsDone')), ["prevent"]))
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", null, "Stand %", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('unitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[33] || (_cache[33] = _createElementVNode("th", null, "Prozentuale Verteilung", -1)),
                      _cache[34] || (_cache[34] = _createElementVNode("th", null, "Fachkraft", -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (sortBy('unitsDoneBySpecialist')), ["prevent"]))
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", null, "Fachkraft UE", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('unitsDoneBySpecialist'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[35] || (_cache[35] = _createElementVNode("th", null, "Assistenzkraft", -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (sortBy('unitsDoneBySupervisor')), ["prevent"]))
                        }, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", null, "Assistenzkraft UE", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('unitsDoneBySupervisor'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (sortBy('notSignedUnits')), ["prevent"]))
                        }, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "UN fehlt", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('emergencySupervisorUnitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[36] || (_cache[36] = _createElementVNode("th", null, "Einführungsunterlagen", -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (sortBy('lastUnit')), ["prevent"]))
                        }, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", null, "Letzter Termin", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('lastUnit'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("th", null, "CV/GEVA", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachingList.value.data, (coaching) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: coaching.id
                      }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: {
                  name: 'assistedLivingCoachingFirstInterviewForm',
                  params: { id: coaching.id }
                },
                            class: "btn btn-primary"
                          }, {
                            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                              _createTextVNode(" Bericht ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _createElementVNode("th", null, [
                          (coaching.client?.specialFeatures || coaching.client?.specialFeaturesForCoach)
                            ? (_openBlock(), _createBlock(_unref(TypedPopover), {
                                key: 0,
                                clientData: coaching.client,
                                userRole: _unref(currentUserRole),
                                maxWidth: "450px"
                              }, {
                                trigger: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                  _createElementVNode("span", { class: "exclamation-badge" }, "!", -1)
                                ]))]),
                                _: 1
                              }, 8, ["clientData", "userRole"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(coaching?.statusTranslation), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.firstName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.lastName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.operationTypeTranslation), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.aaNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.location?.name), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.fileNumberLandscapeAssociation), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.startDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.endDate), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(getUnitsInWeek)(coaching)), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(coaching?.unitsDone), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(coaching?.unitsDonePercent) + " %", 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.specialistPercentUnitsDone) + " / " + _toDisplayString(coaching?.supervisorPercentUnitsDone), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass(coaching?.selectedSpecialists.length > 1 ? 'popover-custom pb-2 border-bottom border-primary' : '')
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              (coaching?.selectedSpecialists.length > 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(coaching.selectedSpecialists, (data, index) => {
                                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                                      _createTextVNode(_toDisplayString(data.fullName), 1),
                                      _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1))
                                    ]))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(" " + _toDisplayString(getSelectedCoachesData(coaching.selectedSpecialists)), 1)
                          ], 2)
                        ]),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(coaching?.unitsDoneBySpecialist), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass(coaching?.selectedSupervisors.length > 1 ? 'popover-custom pb-2 border-bottom border-primary' : '')
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              (coaching?.selectedSupervisors.length > 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(coaching.selectedSupervisors, (data, index) => {
                                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                                      _createTextVNode(_toDisplayString(data.fullName), 1),
                                      _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1))
                                    ]))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(" " + _toDisplayString(getSelectedCoachesData(coaching.selectedSupervisors)), 1)
                          ], 2)
                        ]),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(coaching?.unitsDoneBySupervisor), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(coaching?.notSignedMeetings), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.introductoryDocumentsStatusTranslation), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.lastUnit), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'unemployedDocumentUpload', params: {
                      id: Number(coaching.unemployed?.id),
                      routeForBack: 'assistedLivingCoachingNewAndActiveList'
                    } },
                            class: "btn btn-primary"
                          }, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode(" CV/GEVA ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (coachingList.value?.pagination?.total_pages > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: coachingList.value?.pagination?.total_pages,
                    currentPage: coachingList.value?.pagination?.current_page,
                    totalItems: coachingList.value?.pagination?.total_items,
                    perPage: coachingList.value?.pagination?.items_per_page,
                    onPagechanged: getCoachingList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})